import React from 'react';
import { Link } from 'gatsby';

export default () => {
  return (
    <div className="main-view rodo-content">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <div className="subtitle bigger">DEFINITIONS</div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Business Days</div>
          <div className="col-lg-9 ">
            days from Monday to Friday with the exclusion of public holidays
            according to the generally applicable provisions of Polish law
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Contact Form</div>
          <div className="col-lg-9">
            Service enabling the Users to send questions to Ulam Labs
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Newsletter</div>
          <div className="col-lg-9">
            a free-of-charge service provided by electronic means, through which
            Ulam Labs informs the Users on news on the Website and Services by
            sending selected and edited content in the form of an electronic
            letter
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Privacy Policy</div>
          <div className="col-lg-9">
            a document governing security of protecting and processing the
            personal data of Users; the Privacy Policy supplements these Terms
            of Service and is available <Link to="/privacy-policy/">here</Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Terms of Service</div>
          <div className="col-lg-9">
            these terms of service regulating the provision of Services through
            the Website
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Website</div>
          <div className="col-lg-9">
            a website available at: <Link to="/">www.ulam.io</Link> administered
            by Ulam Labs
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Ulam Labs/Service Provider</div>
          <div className="col-lg-9 ">
            Konrad Rotkiewicz conducting a business activity under name Ulam
            Labs Konrad Rotkiewicz at ul. Powstańców Śląskich, nr 121, lok. 5
            (53-332 Wrocław), Tax Identification Number NIP: 5010046816,
            National Business Registry number REGON: 021880186
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Contract</div>
          <div className="col-lg-9">
            a distance agreement concluded between the User and the Service
            Provider related to provision of the Services by the Service
            Provider for the User
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">Services</div>
          <div className="col-lg-9">
            free of charge services provided by electronic means by Ulam Labs
            for the User through the Website
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 definition">User</div>
          <div className="col-lg-9">
            a natural person with full capacity to perform acts in law, a legal
            person or organisational unit without legal personality but with
            capacity to perform acts in law, who uses the services of Ulam Labs
            as part of his business or professional activity, upon the terms
            stated in the Terms of Service
          </div>
        </div>
      </div>
      <div className="rodo-list terms">
        <div className="container">
          <ol>
            <li>
              INTRODUCTION
              <ol>
                <li>
                  The Terms of Service prescribe the general terms of use of the
                  Website which enables browsing and reading the content of
                  pages within the Website, using the Contact Form and the
                  Newsletter service.
                </li>
                <li>
                  The Terms of Service are provided to each User on the Website
                  free of charge prior to conclusion of the Contract, as well
                  as—upon User’s request—in a manner which enables the User to
                  obtain, copy and record the content of the Terms of Service by
                  means of a teleinformatic system used by the User.
                </li>
                <li>
                  The User may only use the Services upon becoming acquainted
                  with and accepting the Terms of Service and the Privacy
                  Policy. If the User fails to accept the Terms of Service or
                  the Privacy Policy, the User may not use the Services. In the
                  case of a User who is not a consumer, it is deemed that upon
                  starting to use the Services, the User accepted the Terms of
                  Service and the Privacy Policy without reservations.
                </li>
                <li>
                  The Terms of Service are supplemented by the Privacy Policy,
                  available <Link to="/terms-of-service/">here</Link>.
                </li>
              </ol>
            </li>
            <li>
              GENERAL TERMS AND CONDITIONS OF SERVICE PROVISION
              <ol>
                <li>
                  In order to use the Services and the functionalities of the
                  Website, subject to clause 2.2 below, the User has to meet the
                  following minimum technical requirements: (a) a device with
                  the Internet access; (b) an installed latest version of one of
                  the following online browsers: FireFox, Opera, Edge, Chrome,
                  Safari; and additionally with regard to the Newsletter (c) an
                  active e-mail account.
                </li>
                <li>
                  Using the Website is free of charge, except for possible costs
                  of data transmission resulting from agreements concluded
                  between the User and telecommunication operators.
                </li>
                <li>
                  It is not allowed to provide unlawful content as part of the
                  Services or the Website in a manner contrary to the provisions
                  of the Terms of Service, applicable legal provisions, good
                  practices and rules of social co-existence.
                </li>
                <li>
                  The Website and its elements, including design and content,
                  are protected by copyright or other rights related to
                  intellectual property. Such elements may not be reproduced,
                  distributed or published, as a whole or in part, by the User
                  without consent of Ulam Labs. In particular, the User is not
                  allowed under the Terms of Service to reproduce, disseminate,
                  lend, dispose of or otherwise redistribute the Website
                  elements, directly or indirectly, whether against charge or
                  free of charge, otherwise than through Ulam Labs.
                </li>
                <li>Ulam Labs does not provide Services to consumers.</li>
              </ol>
            </li>
            <li>
              NEWSLETTER
              <ol>
                <li>
                  Ulam Labs provides the Newsletter subscription service for the
                  Users who give their voluntary consent to this by means of the
                  Website functionalities.
                </li>
                <li>
                  In order to activate the Newsletter subscription service, the
                  User needs a device with the Internet connection, an installed
                  and updated Internet browser and an active e-mail address.
                </li>
                <li>
                  In order to subscribe to the Newsletter, the User orders it by
                  means of an interactive form available on the Website,
                  providing User’s e-mail address, and activates the service
                  through a link included in the e-mail sent to the User to the
                  stated address.
                </li>
                <li>
                  Upon activation of the subscription, an agreement for
                  provision of the Newsletter service is concluded between Ulam
                  Labs and the User for an unlimited period of time.
                </li>
                <li>
                  The User may at any time terminate the agreement for provision
                  of the Newsletter service with immediate effect by
                  deactivating the subscription. The User may resign from the
                  Newsletter by activating a relevant link provided in the
                  footnote of each electronic letter sent as part of the
                  Newsletter service.
                </li>
              </ol>
            </li>
            <li>
              CONTACT FORM
              <ol>
                <li>
                  Through the Website, Ulam Labs provides the Contact Form
                  Service consisting in providing the User with free contact
                  with Ulam Labs in order to obtain information about the offer,
                  availability and scope of services provided by Ulam Labs as
                  parf of his business.
                </li>
                <li>
                  Ulam Labs provides also the Contact Form Service in the form
                  of the option of booking a video conference for this purpose.
                  For this purpose, the User should follow the instructions
                  indicated on the Website.
                </li>
              </ol>
            </li>
            <li>
              WITHDRAWAL
              <ol>
                <li>
                  If the User is at the same time a consumer, he/she may
                  withdraw from the Contract without providing the reason by
                  filing a declaration of withdrawal from the Contract with Ulam
                  Labs by filing a relevant declaration of will with Ulam Labs
                  (via e-mail) to the e-mail address:{' '}
                  <a href="mailto:privacy@ulam.io">privacy@ulam.io </a>. The
                  term for withdrawing from the Contract is 14 days from its
                  conclusion. In order to comply with the term referred to in
                  the preceding sentence, it is sufficient to send Ulam Labs,
                  prior to its lapse, the declaration of withdrawal in the form
                  referred to in the first sentence of this clause.
                </li>
                <li>
                  If the User is a consumer, he/she has to bear in mind that the
                  withdrawal right does not apply in the case prescribed in
                  Article 38.13 of the Act on consumer’s rights of 30 May 2014,
                  i.e. in the case of an agreement for providing digital content
                  which is not recorded on a physical data carrier if the
                  provision of the performance has commenced upon express
                  consent of the User prior to the lapse of the term prescribed
                  for withdrawing from the contract and upon being notified by
                  Ulam Labs on the loss of the right to withdraw from the
                  contract. Consequently, if provision of the Services to the
                  User was commenced, the User is not entitled to withdraw from
                  the contract.
                </li>
                <li>
                  The right of withdrawal does not apply also in the case
                  prescribed in Article 38.1 of the Act on consumer’s rights of
                  30 May 2014, i.e. in the case of contracts for services if the
                  entrepreneur provided the service fully upon express consent
                  of the consumer who had been informed before starting the
                  performance that upon completion of the performance by the
                  entrepreneur the consumer will lose the right to withdraw from
                  the contract.
                </li>
              </ol>
            </li>
            <li>
              COMPLAINTS
              <ol>
                <li>
                  The User may file a complaint concerning the operation of the
                  Website and the Services. A complaint should include at least
                  details enabling identification of the User as the complaining
                  person and state reasonable reservations and comments
                  concerning the Website or the Services. The complaint should
                  be sent via e-mail to the e-mail address:{' '}
                  <a href="mailto:privacy@ulam.io">privacy@ulam.io</a> or to the
                  correspondence address of Ulam Labs. If the complaint needs to
                  be complemented, then Ulam Labs will request the User to
                  complement it.
                </li>
                <li>
                  Ulam Labs will take a stance towards the filed complaint
                  within 14 days from receiving it. The User will receive a
                  response at the address, from which the complaint has been
                  sent, or at the address stated by the User in the complaint
                  notification form.
                </li>
              </ol>
            </li>
            <li>
              SPECIFIC RULES
              <ol>
                <li>
                  In the case of Users not being consumers, in particular using
                  the Services as part of their business or professional
                  activity, the following specific provisions are applied: (1)
                  Ulam Labs is not liable for any damage caused to the Users by
                  unintentional fault, whereby the liability of Ulam Labs is
                  limited to actual losses incurred by the User, (2) any
                  disputes arising out of the Contract or User’s use of the
                  Website or the Services are settled by the common court having
                  jurisdiction over the registered office of Ulam Labs.
                </li>
              </ol>
            </li>
            <li>
              AMENDMENT TO THE TERMS OF SERVICE
              <ol>
                <li>
                  Ulam labs may amend these Terms of Service due to material
                  reasons, whether legal (change of generally applicable legal
                  provisions related to Ulam Labs’s activity or change of Ulam
                  Labs’s business form) or technical. The reason for any
                  amendment to the Terms of Service is each time provided in the
                  manner described below.
                </li>
                <li>
                  The Users will be notified on any amendment to these Terms of
                  Service by an e-mail sent 7 days before effective date of the
                  new wording of the Terms of Service. In this time the User who
                  is a consumer must accept the Terms of Service again or refuse
                  to accept them. If in turn the User who is not a consumer
                  fails to terminate the provision of Services by Ulam Labs
                  within the said term, the User is deemed to have accepted the
                  Terms of Service in their amended wording without
                  reservations.
                </li>
                <li>
                  Any Orders filed prior to the effective date of an amendment
                  to the Terms of Service are processed in accordance with the
                  content of the Terms of Service as applicable at that date.
                  Amendments to the Terms of Service may not infringe the
                  acquired rights of Users.
                </li>
              </ol>
            </li>
            <li>
              FINAL PROVISIONS
              <ol>
                <li>
                  The governing law for liabilities resulting from the Terms of
                  Service is Polish law. Any contracts shall be concluded in the
                  Polish language.
                </li>
                <li>
                  A consumer may take advantage of dispute resolution methods
                  which are alternative to court proceedings (ADR), in
                  particular through mediation, conciliation or arbitration
                  (arbitration court). The list of institutions to which a
                  consumer may refer for dispute settlement within the frames of
                  ADR is available{' '}
                  <a href="http://ec.europa.eu/consumers/solving_consumer_disputes/non-judicial_redress/national-out-of-court-bodies/index_en.htm">
                    here
                  </a>
                  .
                </li>
                <li>
                  A consumer may also take advantage of out-of-court means of
                  considering complaints and seeking claims by submitting
                  his/her complaint through the EU ODR online application
                  available{' '}
                  <a href="http://ec.europa.eu/consumers/odr/">here</a>.
                </li>
                <li>
                  If the User resigns from taking advantage from ADR or ODR, any
                  disputes arising out of the Terms of Service or Contracts will
                  be settled by a common court with the jurisdiction determined
                  according to the rules as prescribed by a legal act applicable
                  to the User being a consumer.
                </li>
                <li>
                  Any disputes arising between Ulam Labs and the User not being
                  a consumer will be referred to the court with the local
                  jurisdiction over the registered office of Ulam Labs.
                </li>
              </ol>
            </li>
          </ol>
          These Terms of Service come into effect as of: 17.02.2020
        </div>
      </div>
    </div>
  );
};
